import type { RoomModifier } from '@crackpoint/shared/types';
import { useTheme } from './ThemeProvider';

interface ModifierBannerProps {
  modifier: RoomModifier;
}

const MODIFIER_SEVERITY: Record<RoomModifier['id'], 'warning' | 'error'> = {
  clean: 'warning',
  sparse: 'warning',
  noisy: 'warning',
  locked: 'error',
  dark: 'error',
};

export function ModifierBanner({ modifier }: ModifierBannerProps) {
  const { theme } = useTheme();

  if (modifier.id === 'clean') {
    return null;
  }

  const severity = MODIFIER_SEVERITY[modifier.id];
  const bannerColour = severity === 'error' ? theme.colours.accent.error : theme.colours.accent.warning;

  return (
    <div
      className="modifier-banner"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing.md,
        padding: `${theme.spacing.sm} ${theme.spacing.md}`,
        backgroundColor: `${bannerColour}20`,
        border: `2px solid ${bannerColour}`,
        borderRadius: theme.borders.radius.md,
        color: theme.colours.text.primary,
        fontFamily: theme.typography.fontFamily,
      }}
    >
      <span
        className="modifier-banner__icon"
        style={{
          fontSize: theme.typography.fontSize.xl,
          color: bannerColour,
        }}
      >
        ⚠️
      </span>

      <div className="modifier-banner__content" style={{ flex: 1 }}>
        <div
          className="modifier-banner__name"
          style={{
            fontSize: theme.typography.fontSize.md,
            fontWeight: theme.typography.fontWeight.bold,
            color: bannerColour,
            marginBottom: theme.spacing.xs,
          }}
        >
          {modifier.name}
        </div>

        <div
          className="modifier-banner__description"
          style={{
            fontSize: theme.typography.fontSize.sm,
            color: theme.colours.text.secondary,
            lineHeight: theme.typography.lineHeight.normal,
          }}
        >
          {modifier.description}
        </div>
      </div>
    </div>
  );
}
